import React from 'react';

function ViewModal({ toggleModal, data, itemValue, source }) {
    const mainDataKey = source?.includes('Count') ? source?.split('Count')[0] : null;

    return (
        <div className='modal-overlay'>
            <div className='modal-container' style={{ 'width': data && data.childrenItems?.length > 6 ? '' : 'min-content' }}>
                <div className='modal-header'>
                    <span>{data?.viewTitle}</span>
                    <se-icon size='small' option='button' onClick={toggleModal}>action_close</se-icon>
                </div>
                <div className='modal-body' style={{margin: '10px 15px'}}>
                    {
                        <ol style={{ listStyleType: 'decimal'}}>
                                                {Array.isArray(itemValue?.[mainDataKey]) &&
                                                    itemValue[mainDataKey].map((value, key) => (
                                                        <li key={key} style={{width: 'fit-content'}}>{value}</li>
                                                    ))}
                        </ol>
                    }
                </div>
                <div className='modal-footer'>
                    <se-button option="outline" onClick={toggleModal}>Close</se-button>
                </div>
            </div>
        </div>
    )
}
export default ViewModal;